const authentication = require('react-azure-adb2c').default;





export const login = (values: any) => {

    const url = process.env.REACT_APP_API_OPENROOM_EX_URL + `/v1/transfer/detail`;

    // const url = `http://localhost:5000/v1/transfer/detail`;

    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),

        headers: { 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};


